<template>
<div id="menus">
    <section class="z100">
        <nav class="navbar nav-shadow navbar-expand-lg navbar-light bg-light">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
            <a href="https://www.cctexas.com/">
                <img src="../index_files/images/official-seal-svg.svg" alt="City Seal Icon" class="logo-hidden">
            </a>
            <a href="/">
                <img src="../index_files/images/cbb.svg" alt="Clean Bays Blueprint Logo" height="90" class="logo-hidden">
            </a>
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item active">
                <a class="nav-link nav-hover" href="/"><strong>Home</strong></a>
              </li>
              <li class="nav-item active">
                <a class="nav-link nav-hover" href="./documents.html"><strong>Documents</strong></a>
              </li>
              <li class="nav-item active">
                <a class="nav-link nav-hover" href="./about.html"><strong>About</strong></a>
              </li>
              <li class="nav-item active">
                <a class="nav-link nav-hover" href="./invest.html"><strong>Investing</strong></a>
              </li>
                <li class="nav-item active">
                <a class="nav-link nav-hover" href="./doing.html"><strong>Do Your Part</strong></a>
              </li>
            </ul>
          </div>
        </nav>
    </section>
</div>
</template>

<script>
export default {
  name: 'menus',
  data () {
    return {
      
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Menus.vue